import { useState, useCallback } from "react";

export function useAdminActions({ saveArticle, deleteArticle, fetchArchivedArticles, unarchiveAll, unarchiveArticle, deleteAllArticles, importDocx, refreshAll, currentPage, setCurrentPage, formatApiErrorDetail }) {
  const [editingArticle, setEditingArticle] = useState(null);
  const [showArticleModal, setShowArticleModal] = useState(false);
  const [showArchivedPanel, setShowArchivedPanel] = useState(false);

  const handleSaveArticle = useCallback(async (articleData) => {
    await saveArticle(articleData, editingArticle?.id);
    refreshAll(currentPage);
    setEditingArticle(null);
  }, [saveArticle, editingArticle, refreshAll, currentPage]);

  const handleEditArticle = useCallback((article) => {
    setEditingArticle(article);
    setShowArticleModal(true);
  }, [setEditingArticle, setShowArticleModal]);

  const handleDeleteArticle = useCallback(async (articleId) => {
    if (!window.confirm("Are you sure you want to delete this article?")) return;
    await deleteArticle(articleId);
    refreshAll(currentPage);
  }, [deleteArticle, refreshAll, currentPage]);

  const handleImportDocx = useCallback(async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const data = await importDocx(file);
      setEditingArticle({ title: data.title, content: data.content, image_url: "" });
      setShowArticleModal(true);
    } catch (err) {
      alert(formatApiErrorDetail(err.response?.data?.detail));
    }
    event.target.value = "";
  }, [importDocx, formatApiErrorDetail, setEditingArticle, setShowArticleModal]);

  const handleOpenArchivedPanel = useCallback(() => {
    setShowArchivedPanel(true);
  }, [setShowArchivedPanel]);

  const handleCloseArchivedPanel = useCallback(() => {
    setShowArchivedPanel(false);
  }, [setShowArchivedPanel]);

  const handleDeleteAllArticles = useCallback(async () => {
    if (!window.confirm("WARNING: This will permanently DELETE ALL articles. This cannot be undone. Are you sure?")) return;
    if (!window.confirm("Are you REALLY sure? Confirm you have backups.")) return;
    try {
      alert(await deleteAllArticles());
      setCurrentPage(1);
      refreshAll(1);
    } catch {
      alert("Failed to delete articles");
    }
  }, [deleteAllArticles, setCurrentPage, refreshAll]);

  const closeArticleModal = useCallback(() => {
    setShowArticleModal(false);
    setEditingArticle(null);
  }, [setShowArticleModal, setEditingArticle]);

  return {
    editingArticle, showArticleModal, setShowArticleModal,
    showArchivedPanel, handleOpenArchivedPanel, handleCloseArchivedPanel,
    fetchArchivedArticles, unarchiveAll, unarchiveArticle,
    handleSaveArticle, handleEditArticle, handleDeleteArticle,
    handleImportDocx, handleDeleteAllArticles,
    closeArticleModal,
  };
}
